import { render, staticRenderFns } from "./NtdUsers.vue?vue&type=template&id=a5f55b0e&scoped=true"
import script from "./NtdUsers.vue?vue&type=script&lang=ts"
export * from "./NtdUsers.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5f55b0e",
  null
  
)

export default component.exports